<template>
    <div v-if="plan && plan.src" :class="['visual-plan', {'is-open': isOpen}, {'is-iframe': visualInnerVersion}]">
        <button class="visual-plan__open-button" @click="isOpen = !isOpen">Открыть план комплекса</button>
        <div class="visual-plan__container">
            <button class="visual-plan__close" @click="isOpen = !isOpen">
                <iconClose/>
            </button>
            <div class="visual-plan__content">
                <img :src="plan.src" class="visual-plan__image">
                <div class="visual-plan__hover">
                    <img :src="plan.src">
                </div>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Plan.scss";
</style>

<script>
import iconClose from '../Icons/icon-close';
import {mapGetters} from 'vuex';
import {Utils} from 'common/scripts/utils';

export default {
    data: () => {
        return {
            isOpen: false
        };
    },

    components: {
        iconClose
    },

    computed: {
        ...mapGetters({
            plan              : 'GET_PLAN',
            visualInnerVersion: 'GET_VISUAL_VERSION'
        })
    },

    methods: {
        bindEvents() {
            const events = ['resize', 'orientationchange'];

            events.forEach((event) => {
                window.addEventListener(event, this.onResize.bind(this));
            });
        },

        onResize() {
            if (!Utils.isMobile()) {
                this.isOpen = false;
            }
        }
    }
};
</script>

